<template>
  <div class="p-4 transition-shadow border rounded-lg shadow-sm hover:shadow-lg bg-white">
    <div class="flex flex-col gap-4 justify-center items-center">
      <font-awesome-icon :icon="icon.name" class="text-6xl text-menuItem" :style="{'color':icon.color}"></font-awesome-icon>
      <p class="text-4xl text-menuItem">
        {{title}}
      </p>
      <p class="text-base text-gray-400">
        {{description}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "simpleCards",
  props:["icon","title","description"]
}
</script>

<style scoped>

</style>